import Form from 'react-bootstrap/Form';
import { senders } from '../../../utils/dropdownOptions';
import Button from 'react-bootstrap/esm/Button';
import { useState } from 'react';
import { EditSenderAddressModal } from '../../Modals/EditSenderAddressModal';

export const SenderInformation = ({ formik, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const errors = isReturnShipmentTab ? formik.errors.returnData : formik.errors;
    const touched = isReturnShipmentTab ? formik.touched.returnData : formik.touched;
    const { shipperName, shipperCompany, shipperAddress1, shipperAddress2, shipperCity, shipperState, shipperPostalCode } = values;
    const initialFormData = {
        contactName: values.shipperName,
        companyName: values.shipperCompany,
        country: values.shipperCountry,
        postalCode: values.shipperPostalCode,
        address1: values.shipperAddress1,
        address2: values.shipperAddress2,
        city: values.shipperCity,
        state: values.shipperState,
        telephone: values.shipperTelephone,
        email: values.shipperEmail,
        residentialAddress: values.shipperResidentialAddress
    }
    const [show, setShow] = useState(false);
    const [editAddressFormData, setEditAddressFormData] = useState(initialFormData);

    const handleShow = () => {
        const currentSender = {
            contactName: values.shipperName,
            companyName: values.shipperCompany,
            country: values.shipperCountry,
            postalCode: values.shipperPostalCode,
            address1: values.shipperAddress1,
            address2: values.shipperAddress2,
            city: values.shipperCity,
            state: values.shipperState,
            telephone: values.shipperTelephone,
            email: values.shipperEmail,
            residentialAddress: values.shipperResidentialAddress
        }
        setEditAddressFormData(currentSender);
        setShow(true);
    }
    const handleClose = () => setShow(false);

    const handleEditAddressFormChange = (e) => {
        const { name, value } = e.target;
        setEditAddressFormData({ ...editAddressFormData, [name]: value });
    }

    const handleEditAddressCheckChange = (e) => {
        const { name, checked } = e.target;
        setEditAddressFormData({ ...editAddressFormData, [name]: checked });
    }

    const saveEditAddressForm = () => {
        const newVals = {
            shipperName: editAddressFormData.contactName,
            shipperTelephone: editAddressFormData.telephone,
            shipperEmail: editAddressFormData.email,
            shipperCountry: editAddressFormData.country,
            shipperAddress1: editAddressFormData.address1,
            shipperAddress2: editAddressFormData.address2,
            shipperCity: editAddressFormData.city,
            shipperState: editAddressFormData.state,
            shipperPostalCode: editAddressFormData.postalCode,
            shipperCompany: editAddressFormData.companyName,
            shipperResidentialAddress: editAddressFormData.residentialAddress
        }
        if (isReturnShipmentTab) {
            formik.setValues({
                ...formik.values,
                returnData: {
                    ...formik.values.returnData,
                    ...newVals
                }
            });
        } else {
            formik.setValues({
                ...formik.values,
                ...newVals
            });
        }
        handleClose();
    }

    const handleSenderChange = (e) => {
        // TODO this works but maybe look for better way to write it...
        formik.handleChange(e);
        const shipper = senders.find((s) => s.id === e.target.value);
        const newVals = {
            shipper: shipper ? e.target.value : '',
            shipperName: shipper ? shipper.contactName : '',
            shipperTelephone: shipper ? shipper.telephone : '',
            shipperEmail: shipper ? shipper.email : '',
            shipperCountry: shipper ? shipper.country : '',
            shipperAddress1: shipper ? shipper.address1 : '',
            shipperAddress2: shipper ? shipper.address2 : '',
            shipperCity: shipper ? shipper.city : '',
            shipperState: shipper ? shipper.state : '',
            shipperPostalCode: shipper ? shipper.postalCode : '',
            shipperCompany: shipper ? shipper.companyName : '',
            shipperResidentialAddress: shipper ? shipper.residential : false
        }
        if (isReturnShipmentTab) {
            formik.setValues({
                ...formik.values,
                returnData: {
                    ...formik.values.returnData,
                    ...newVals
                }
            });
        } else {
            formik.setValues({
                ...formik.values,
                ...newVals
            });
        }
    }

    const fillFromOutbound = () => {
        const { values } = formik;
        formik.setValues({
            ...values,
            returnData: {
                ...values.returnData,
                country: values.country,
                contactName: values.contactName,
                companyName: values.companyName,
                address1: values.address1,
                address2: values.address2,
                postalCode: values.postalCode,
                stateProvince: values.stateProvince,
                city: values.city,
                telephone: values.telephone,
                ext: values.ext,
                residentialAddress: values.residentialAddress,
                poNum: values.poNum,
                invoiceNum: values.invoiceNum
            }
        })
    }

    const clearReturn = () => {
        const { values } = formik;
        formik.setValues({
            ...values,
            returnData: {
                ...values.returnData,
                country: '',
                contactName: '',
                companyName: '',
                address1: '',
                address2: '',
                postalCode: '',
                stateProvince: '',
                city: '',
                telephone: '',
                ext: '',
                residentialAddress: false,
                poNum: '',
                invoiceNum: ''
            }
        })
    }

    return (
        <>
            <div className='form-group'>
                {isReturnShipmentTab && !formik.values.includeReturnLabel &&
                    <Form.Check
                        inline
                        type='checkbox'
                        id='isReturnOnly'
                        label='Standalone return shipment'
                        checked={formik.values.isReturnOnly}
                        {...formik.getFieldProps('isReturnOnly')}
                    />}
                {isReturnShipmentTab &&
                    <Form.Check
                        inline
                        type='checkbox'
                        id='requestPdfLabels'
                        label='Request labels in PDF'
                        checked={formik.values.requestPdfLabels}
                        {...formik.getFieldProps('requestPdfLabels')}
                    />}
            </div>
            {isReturnShipmentTab &&
                <div className='form-group'>
                    <Button onClick={fillFromOutbound} variant='secondary' size='sm' style={{ marginRight: '0.5rem' }}>Fill in data from outbound</Button>
                    <Button onClick={clearReturn} variant='secondary' size='sm'>Clear return</Button>
                </div>}
            <Form.Group className='form-group'>
                <Form.Label>Change sender</Form.Label>
                <Form.Select
                    id={isReturnShipmentTab ? 'returnData.shipper' : 'shipper'}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.shipper' : 'shipper')}
                    onChange={(e) => handleSenderChange(e)}
                >
                    <option value=''>Select an option</option>
                    {
                        senders.map((s) => (
                            <option key={s.id} value={s.id}>{s.id}</option>
                        ))
                    }
                </Form.Select>
                {
                    errors?.shipper && touched?.shipper ? (
                        <div className='error'>{errors?.shipper}</div>
                    ) : null
                }
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>Current sender</Form.Label>
                <Form.Control
                    as='textarea'
                    rows={4}
                    disabled
                    value={`${shipperName}\n${shipperCompany}\n${shipperAddress1}${shipperAddress2 && ', ' + shipperAddress2}\n${shipperCity}${shipperCity && ','} ${shipperState} ${shipperPostalCode}`}
                />
            </Form.Group>
            <Button onClick={handleShow} variant='secondary' size='sm'>View/Edit</Button>
            <EditSenderAddressModal
                formik={formik}
                isReturnShipmentTab={isReturnShipmentTab}
                show={show}
                handleClose={handleClose}
                formData={editAddressFormData}
                setFormData={setEditAddressFormData}
                handleChange={handleEditAddressFormChange}
                handleCheckChange={handleEditAddressCheckChange}
                saveData={saveEditAddressForm}
            />
        </>
    )
}